import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useBreakpoint, useModalDialog } from '~/composables';
import SolutionsCarouselSlider from '~/components/sections/sliderSection/SolutionsCarouselSlider.vue';
import SolutionsCarouselSliderMobile from '~/components/sections/sliderSection/SolutionsCarouselSliderMobile.vue';
import VideoPlayerModal from '~/components/VideoPlayerModal.vue';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsCarousel',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const sliderNav = ref();
const activeSlide = ref(0);
const videoPlayer = ref();
const videoInModal = ref<undefined | string>();
const swiper = ref<any>();
const swiperMobile = ref<any>();
const { isOpen: isModalOpen, open, close } = useModalDialog('video-player');

const playVideo = (videoId: string) => {
  videoInModal.value = videoId;
  open();
};

const closeVideo = () => {
  videoInModal.value = undefined;
  close();
};

const onSlideChange = (i: number) => {
  activeSlide.value = i;

  const nav = sliderNav.value as HTMLElement;
  const navButton = nav.children[i] as HTMLElement;

  nav.parentElement!.scroll({
    left: navButton.offsetLeft - navButton.offsetWidth,
  });
};

const changeSlide = (i: number) => {
  if (swiper.value && !swiper.value.destroyed) swiper.value.slideTo(i);

  if (swiperMobile.value && !swiperMobile.value.destroyed)
    swiperMobile.value.slideTo(i);
};

const onSwiperInit = (slider: any) => {
  swiper.value = slider;
};

const onSwiperMobileInit = (slider: any) => {
  swiperMobile.value = slider;
};

return { __sfc: true,isDesktop, sliderNav, activeSlide, videoPlayer, videoInModal, swiper, swiperMobile, isModalOpen, open, close, playVideo, closeVideo, onSlideChange, changeSlide, onSwiperInit, onSwiperMobileInit, SolutionsCarouselSlider, SolutionsCarouselSliderMobile, VideoPlayerModal }
}

})